export enum LeadMaterialEnum {
  'EVA' = 'EVA',
  'PVC' = 'PVC',
  'PET' = 'PET',
  'ABS' = 'ABS',
  'Placa - Steel' = 'Placa - Steel',
  'Perfiles - Steel' = 'Perfiles - Steel',
  'Lamina - Steel' = 'Lamina - Steel',
  'Otros - polimeros' = 'Otros - polimeros',
  'Varilla - Steel' = 'Varilla - Steel',
  'PE' = 'PE',
  'PP' = 'PP',
  'PC' = 'PC',
  'TPE' = 'TPE',
  'Viga - Steel' = 'Viga - Steel',
  'Barilla - Steel' = 'Barilla - Steel',
  'PS' = 'PS',
  'Tubo - Steel' = 'Tubo - Steel',
  'PTR' = 'PTR',
  'Aluminio' = 'Aluminio',
  'Otros - Steel' = 'Otros - Steel',
}

export enum LeadCompanyManufacturedProductEnum {
  'Botella' = 'Botella',
  'hidrotomas' = 'hidrotomas',
  'Acanala Lamunas' = 'Acanala Lamunas',
  'Anfora de plastico' = 'Anfora de plastico',
  'bolsa' = 'bolsa',
  'Inyectan y extruyen' = 'Inyectan y extruyen',
  'Defensa para automoviles' = 'Defensa para automoviles',
  'Masterbach' = 'Masterbach',
  'tuberia' = 'tuberia',
  'BOLSA Y MANGUERA' = 'BOLSA Y MANGUERA',
  'Envases de aceites' = 'Envases de aceites',
  'Lamina galvanizada sin flour calibre 20 a 5 pies en rollos de 4 toneladas' = 'Lamina galvanizada sin flour calibre 20 a 5 pies en rollos de 4 toneladas',
  'Piezas para sistemas de riego' = 'Piezas para sistemas de riego',
  'Vasos y platos desechables' = 'Vasos y platos desechables',
  'malla plástica' = 'malla plástica',
  'Mangueras y Bote' = 'Mangueras y Bote',
  'CONSTRUYE' = 'CONSTRUYE',
  'Artículos del Hogar' = 'Artículos del Hogar',
  'Placas base para el desarrollo de estructuras metalizas' = 'Placas base para el desarrollo de estructuras metalizas',
  'FABRICACION AUTOMOTRIZ' = 'FABRICACION AUTOMOTRIZ',
  'Mangueras, extensiones, plantillas' = 'Mangueras, extensiones, plantillas',
  'Materiales para el hogar en general' = 'Materiales para el hogar en general',
  'Producto dental' = 'Producto dental',
  'cajas' = 'cajas',
}

export enum LeadCompanySizeEnum {
  'micro_company' = 'micro_company',
  'small_company' = 'small_company',
  'medium_company' = 'medium_company',
  'large_company' = 'large_company',
}

export enum LeadCustomerTypeEnum {
  'reseller' = 'reseller',
  'builder' = 'builder',
  'trader' = 'trader',
  'manufacturer_and_provider' = 'manufacturer_and_provider',
  'manufacturer' = 'manufacturer',
}

export enum LeadProfileTypeEnum {
  'inbound' = 'inbound',
  'outbound' = 'outbound',
}

export enum LeadOriginEnum {
  'wa_kai' = 'wa_kai',
  'wa_kai_steel' = 'wa_kai_steel',
  'prospeccion_directa' = 'prospeccion_directa',
  'prospeccion_directa_google' = 'prospeccion_directa_google',
  'mercai_co' = 'mercai_co',
  'plataforma' = 'plataforma',
  'app' = 'app',
  'fb_ads' = 'fb_ads',
  'mercai_ai_steel' = 'mercai_ai_steel',
  'gerdau_list' = 'gerdau_list',
  'referido' = 'referido',
  'aturo_list' = 'aturo_list',
  'plataforma_steel' = 'plataforma_steel',
  'mercai_ai' = 'mercai_ai',
}

export enum LeadIndustryEnum {
  'Automotriz' = 'Automotriz',
  'Manufactura y Tecnología' = 'Manufactura y Tecnología',
  'Comercio' = 'Comercio',
  'Médico' = 'Médico',
  'Manufactura' = 'Manufactura',
  'Construcción' = 'Construcción',
  'Empaque' = 'Empaque',
  'Otros' = 'Otros',
  'Electrónica' = 'Electrónica',
  'Salud' = 'Salud',
  'Manufactura Industrial' = 'Manufactura Industrial',
  'Energía' = 'Energía',
  'Hogar' = 'Hogar',
}

export enum LeadMoscowClassificationEnum {
  'must' = 'must',
  'should' = 'should',
  'could' = 'could',
  'wont' = 'wont',
}

export enum LeadPurchaseFrequencyEnum {
  'weekly' = 'weekly',
  'biweekly' = 'biweekly',
  'monthly' = 'monthly',
  'bimonthly' = 'bimonthly',
  'quarterly' = 'quarterly',
  'semiannualy' = 'semiannualy',
  'unknown' = 'unknown',
}

export interface LeadAiQualificationDataProps {
  externalConversationUuid: string
  finalScoring: number
  qualifiedAt: string
  recommendation: string
}

export interface LeadProps {
  uuid: string
  reference?: string

  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  whatsappPhone?: string

  status?: string
  companyName?: string
  companySize?: keyof typeof LeadCompanySizeEnum
  customerType?: keyof typeof LeadCustomerTypeEnum
  profileType?: keyof typeof LeadProfileTypeEnum

  origin?: keyof typeof LeadOriginEnum
  industry?: keyof typeof LeadIndustryEnum
  productOfInterest?: string
  companyManufacturedProduct?: keyof typeof LeadCompanyManufacturedProductEnum
  monthlyBuyingPotential?: string
  moscowClassification?: keyof typeof LeadMoscowClassificationEnum
  purchaseFrequency?: keyof typeof LeadPurchaseFrequencyEnum
  companyAge?: number

  postalCode?: string
  region?: string

  saleDevelopmentRepresentative?: number | null
  lifeCycleStage?: string

  hubspotIdentifier?: number | null
  profile?: number | null

  aiQualificationData?: LeadAiQualificationDataProps

  createdAt: string
  updatedAt: string
}

export interface LeadListWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: LeadProps[]
}
